var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"subtitle"},[_vm._v("Нет доступных анкет для заполнения!")])])}]

export { render, staticRenderFns }